module.exports = __webpack_public_path__ + "static/assets/642822f76a7acad2af7f2e81988e84ea.svg";